import styled, { css, keyframes } from 'styled-components'

import { color } from 'styles/global'
import { space } from 'styles/utils'

const bounce = keyframes`
  10% {
    top:2px
  }

  30% {
    top:10px
  }

  60% {
    top:7px
  }

  80% {
    top:18px
  }

  100% {
    top:16px
  } 
`

export const Wrapper = styled.div<{ playing?: boolean }>`
  display: inline-flex;
  flex-shrink: 0;
  height: 20px;
  margin-left: auto;
  margin-right: ${space(3)};
  margin-top: ${space(3)};
  pointer-events: none;
  position: relative;
  width: 20px;

  & > span {
    background-color: ${color('interactive')};
    bottom: 0;
    left: 0;
    position: absolute;
    transform-origin: bottom;
    transition: opacity 0.3s ease-out;
    width: ${space(1)};

    &:nth-of-type(2) {
      animation-delay: -2.2s;
      left: 8px;
    }

    &:nth-of-type(3) {
      animation-delay: -3.7s;
      left: 16px;
    }
  }
  ${({ playing }) =>
    playing &&
    css`
      & > span {
        animation: ${bounce} 1.2s ease infinite alternate;
        top: 18px;
        &:nth-of-type(2) {
          top: 12px;
        }
        &:nth-of-type(3) {
          top: 8px;
        }
      }
    `}
  @media only screen and (min-width: 650px) {
    display: none;
  }
`
export const PlayingIndicator = ({ playing }: { playing: boolean }) => (
  <Wrapper playing={playing}>
    <span />
    <span />
    <span />
  </Wrapper>
)
